export const defaultPhoneModel = {
  country: 'US',
  code: '+1',
  phone: '',
  ext: '',
};
